export const getInformation = () => {
    return fetch('/api/v2/accounts/registration/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const createUser = (body) => {
    return fetch('/api/v2/accounts/registration/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(body),
    });
};

export const incompleteRegistration = (body) => {
    return fetch('/api/v1/incomplete-registrations/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
};

export const checkCouponCode = (body, signal) => {
    return fetch('/api/v2/accounts/validate-promotion-code/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(body),
        signal: signal ?? undefined,
        credentials: window.csrf_token ? 'include' : 'omit',
    });
};

export const updateSubscriptionApi = (body) => {
    return fetch('/api/v2/accounts/subscription/', {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(body),
    });
};

export const checkEmail = ({ email }) => {
    return fetch(`/customers/check-email-exist/?email=${encodeURIComponent(email)}`);
};
